var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.825,
    height: 12,
    viewBox: "0 0 6.825 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down_arrow",
    "data-name": "down arrow",
    d: "M2.565,12.977a.761.761,0,0,0-.155.227.684.684,0,0,0-.056.281.694.694,0,0,0,.1.36.722.722,0,0,0,.257.257.7.7,0,0,0,.365.1.668.668,0,0,0,.51-.213L8.706,8.746H8l5.116,5.238a.685.685,0,0,0,.516.213A.7.7,0,0,0,14,14.1a.722.722,0,0,0,.257-.257.694.694,0,0,0,.1-.36.679.679,0,0,0-.212-.508L8.893,7.613a.7.7,0,0,0-.247-.182.73.73,0,0,0-.292-.06.739.739,0,0,0-.546.241Z",
    transform: "translate(14.197 -2.354) rotate(90)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.09a53ab7b834356d2512e9a11745ec04.svg";
export { ForwardRef as ReactComponent };